import {
  ChatbotConversationDirection,
  ChatbotConversationType,
  ChatbotResponseType,
  IChatbotConversation,
  IChatbotResponse,
} from 'chatbot/types';

export const chatbotResponseToConversationMap = (
  response: IChatbotResponse
): IChatbotConversation => {
  switch (response.type) {
    case ChatbotResponseType.MESSAGE:
      return {
        type: ChatbotConversationType.MESSAGE,
        title: response.title,
        message: response.message,
        direction: ChatbotConversationDirection.INCOMING,
      };
    case ChatbotResponseType.QUESTIONS:
      return {
        type: ChatbotConversationType.QUESTIONS,
        title: response.title,
        questions: response.questions,
      };
    case ChatbotResponseType.PARTS_LIST:
      return {
        type: ChatbotConversationType.PARTS_LIST,
        title: response.title,
        parts: response.parts,
      };
    default:
      return null;
  }
};
